import { EstadoCaso, OrigenCaso } from '../../../api/altasCasosApi';
import type { FctFamilia, FctNombreIcono } from '../../../fct/react';

/**
 * Definición visual de los 6 estados del caso (spec §2).
 * COPIADO CON REVISIÓN del mockup T05 (`lib/estado.ts`, FUENTE_HISTORICA — único fichero de
 * lógica autorizado a heredarse junto a FilaComparada y el patrón de pestañas): en la revisión
 * se re-clavea de literales string a los IDs numéricos reales del catálogo
 * `FC_C_ALTA_CASO_ESTADO` del backend. Las etiquetas se conservan tal cual ("Registro eliminado"
 * se etiqueta **"Descartada"**). Los colores de Ant Design (ajuste 1 de María: gold / naranja /
 * purple) se sustituyen por la familia del semáforo del manual + icono (GCVSC-I001 R-11,
 * `mapeo-estados.md` §D.1): la distinción entre estados de la misma familia la da el icono.
 */
export const ESTADO_LABELS: Record<EstadoCaso, string> = {
  [EstadoCaso.Pendiente]: 'Pendiente',
  [EstadoCaso.EnEspera]: 'En espera',
  [EstadoCaso.RegistroValidado]: 'Registro validado',
  [EstadoCaso.ClienteExistenteActualizado]: 'Cliente existente actualizado',
  [EstadoCaso.RegistroEliminado]: 'Descartada',
  [EstadoCaso.AltaDirecta]: 'Alta directa',
};

export const ESTADO_FAMILIAS: Record<EstadoCaso, { familia: FctFamilia; icono: FctNombreIcono }> = {
  [EstadoCaso.Pendiente]: { familia: 'aviso', icono: 'hora' },
  [EstadoCaso.EnEspera]: { familia: 'aviso', icono: 'bloqueado' },
  [EstadoCaso.RegistroValidado]: { familia: 'exito', icono: 'completado' },
  [EstadoCaso.ClienteExistenteActualizado]: { familia: 'exito', icono: 'check' },
  [EstadoCaso.RegistroEliminado]: { familia: 'neutro', icono: 'cancelado' },
  [EstadoCaso.AltaDirecta]: { familia: 'exito', icono: 'mas' },
};

/** El origen es una categoría, no un estado: etiqueta neutra sin color (regla 3 del manual). */
export const ORIGEN_LABELS: Record<OrigenCaso, string> = {
  [OrigenCaso.Web]: 'Web',
  [OrigenCaso.Manual]: 'Manual',
  [OrigenCaso.Asesor]: 'Asesor',
};

/** Ref legible del caso a partir del ID (D-GC-05 §1.2: no hay columna propia). */
export const formatearRef = (idCaso: number): string => `AC-${String(idCaso).padStart(6, '0')}`;
